import {Component, OnInit, OnDestroy} from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit, OnDestroy {

  constructor() { }

  ngOnInit() {
    $('.subHeader').addClass('subCoverFaq');
    $('.faqLink').addClass('activeLink');
    $('.faqLink a').css('color', 'white');
    $('.headline h1').text('F.A.Q.');
  }

  ngOnDestroy() {
    $('.subHeader').removeClass('subCoverFaq');
    $('.faqLink').removeClass('activeLink');
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/faq/faq.component.ts